<!--
 * @FileDescription: 客户优惠券 - Web
 * @Author: 陈文景
 * @Date: 2023-03-17 17:18:07
 * @LastEditors: 最后更新作者
 * @LastEditTime: 最后更新时间
-->
<template>
  <div class="coupons">
    <h3 v-if="isPC">Coupons</h3>

    <div class="content">
      <el-tabs v-model="active" @tab-click="handleClickTab">
        <el-tab-pane label="Available" name="Available" :class="{ 'is-mobile': !isPC }">
          <Available ref="Available" />
        </el-tab-pane>

        <el-tab-pane label="Used" name="Used" :class="{ 'is-mobile': !isPC }">
          <Used ref="Used" />
        </el-tab-pane>

        <el-tab-pane label="Expired" name="Expired" :class="{ 'is-mobile': !isPC }">
          <Expired ref="Expired" />
        </el-tab-pane>
      </el-tabs>

      <span v-if="isPC" class="tips">Only show coupons within one year</span>
    </div>
  </div>
</template>

<script>
import Used from './components/Used.vue'
import Expired from './components/Expired.vue'
import Available from './components/Available.vue'

export default {
  components: {
    Used,
    Expired,
    Available
  },
  data() {
    return {
      active: 'Available'
    }
  },
  mounted() {
    this.$refs.Available.update()
  },
  methods: {
    /**
     * 切换Tab时触发的事件
     *
     * @param {Object} tab 当前切换的tab对象
     */
    handleClickTab(tab) {
      switch (tab.name) {
        case 'Available': // 可用
          this.$refs.Available.update()
          break
        case 'Used': // 已使用
          this.$refs.Used.update()
          break
        case 'Expired': // 已过期
          this.$refs.Expired.update()
          break
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.coupons {
  max-width: 1200px;
  margin: 0 auto;

  h3 {
    color: #000;
    font-size: 18px;
    font-weight: 500;
    margin: 8px 0;
  }

  .content {
    position: relative;
    width: 100%;
    background-color: #fff;

    /deep/.el-tabs__nav-wrap {
      padding: 0 20px;
    }

    .el-tab-pane {
      padding: 0 20px;
      padding-bottom: 8px;
      height: calc(100vh - 150px);
      overflow: auto;
      -ms-overflow-style: none;
      overflow: -moz-scrollbars-none;
      &.is-mobile {
        height: calc(100vh - 99.72px);
      }
      &::-webkit-scrollbar {
        width: 0 !important;
      }
    }

    .tips {
      position: absolute;
      color: #8b93a3;
      top: 10px;
      right: 20px;
    }
  }
}
</style>
